import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('members', app)
  return store
}
